import { redirect, useRouteError } from "react-router-dom";
import GenericErrorDisplay from "../generic-error";
import "./styles.css";

import { path as constructionPath } from "../page-in-constructie";

export const path = "/parteners/";

export async function loader({ request }) {
  return redirect(constructionPath);
}

export function Component() {
  return <></>;
}
Component.displayName = "page-parteneri-sponsori";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-parteneri-sponsori-error";
